import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection";
import createStore from "@Stores/base-factories";

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('version')
  .extendHookCollectionsFactory('versions')
  .factory()

export {
  Provider as VersionProvider,
  useStore as useVersionStore,
}
